import React, { Component } from "react";
import { Alert, Button } from "react-bootstrap";

/**
 * WidgetErrorBoundary - Widget-level error boundary.
 * Catches errors in individual widgets without crashing the entire page.
 */
export default class WidgetErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      retryCount: 0,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    console.error("Widget Error:", this.props.widgetName || "Unknown", error, errorInfo);
  }

  handleRetry = () => {
    this.setState((prev) => ({
      hasError: false,
      error: null,
      errorInfo: null,
      retryCount: prev.retryCount + 1,
    }));
  };

  render() {
    if (this.state.hasError) {
      return (
        <Alert variant="warning" className="m-2">
          <Alert.Heading style={{ fontSize: "1rem" }}>
            <i className="bi bi-exclamation-triangle me-2"></i>
            Widget Error{this.props.widgetName ? `: ${this.props.widgetName}` : ""}
          </Alert.Heading>
          <p style={{ fontSize: "0.875rem" }}>
            This widget encountered an error and couldn't be displayed.
          </p>
          <Button
            variant="outline-warning"
            size="sm"
            onClick={this.handleRetry}
            disabled={this.state.retryCount >= 3}
          >
            <i className="bi bi-arrow-clockwise me-1"></i>
            Retry {this.state.retryCount > 0 ? `(${this.state.retryCount}/3)` : ""}
          </Button>
          {process.env.NODE_ENV === "development" && this.state.error && (
            <pre className="mt-2 bg-light p-2 rounded" style={{ fontSize: "0.75rem", maxHeight: "100px", overflow: "auto" }}>
              {this.state.error.toString()}
            </pre>
          )}
        </Alert>
      );
    }
    return this.props.children;
  }
}
